import React from 'react';
import './App.css';

import tokens from './tokens.json';

import { FixedSizeList as List } from 'react-window';

function renderBase64Token(base64) {
  var binaryString = atob(base64);
  var chars = []
  for (var i = 0; i < binaryString.length; i++) {
    chars.push(binaryString[i])
  }
  return chars.map(
    (c, i)=> { return((32 <= binaryString.charCodeAt(i)) && (binaryString.charCodeAt(i)<= 126)? 
      c.replace(" ", "\u00A0") : 
      <u key={i}>{binaryString.charCodeAt(i).toString(16)}</u>
      )}
    )

}

function filterTextFromBase64Token(base64) {
  var binaryString = atob(base64);
  var chars = []
  for (var i = 0; i < binaryString.length; i++) {
    chars.push(binaryString[i])
  }

  var str = ""

  chars.map(
    (c, i)=> { if ((32 <= binaryString.charCodeAt(i)) && (binaryString.charCodeAt(i)<= 126)) 
      str += c
      else
      str += binaryString.charCodeAt(i).toString(16)
      }
    )

  return str

}


const Row = ({ index, data, style }) => (
  <div className={index % 2 ? 'ListItemOdd' : 'ListItemEven'} style={style}>
    <table>
      <tbody>
      <tr>
        <td>
          {data[index].id}
        </td>
        <td>
          <span className="token">
          {
            renderBase64Token(data[index].token)
          }
          </span>
        </td>
        {
          data[index].decoded?
          <td>
            <span className="decoded">
            {
              data[index].decoded.replace(" ", "\u00A0").replace("\t", "\\t").replace("\n", "\\n").replace("\r", "\\r")
            }
            </span>
          </td>
          :
          null
        }
      </tr>
      </tbody>
    </table>
  </div>
);



function App() {

  const [filteredTokens, setFilteredTokens] = React.useState(tokens);
  const [filter, setFilter] = React.useState("");

  const handleFilterChange = (event) =>{


    setFilteredTokens(tokens.filter(
      (t)=>(filterTextFromBase64Token(t.token).toLowerCase().includes(event.target.value.toLowerCase()) || 
      ((t.decoded) && t.decoded.toLowerCase().replace(" ", "\u00A0").replace("\t", "\\t").replace("\n", "\\n").replace("\r", "\\r").includes(event.target.value.toLowerCase())))
      )
    )



    setFilter(event.target.value)
  }


  


  return (
    <>
    <table>
      <tbody>
      <tr>
        <td>
          <List
            className="List"
            height={500}
            itemCount={filteredTokens.length}
            itemSize={35}
            width={500}
            itemData={filteredTokens}
            itemKey={(index, data)=>data[index].id}
            initialScrollOffset={56413*35}
          >
            {Row}
          </List>
        </td>
      </tr>
      <tr>
        <td>
        <input type="text" id="filter_token" name="filter_token" placeholder="Search for tokens here" value={filter} onChange={handleFilterChange}/>
        </td>
      </tr>
      </tbody>
    </table>
    </>
  )  
}

export default App;
